var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{ref:"input",class:`dn-form-input-component ${_vm.classes}`,attrs:{"value":_vm.value,"state":_vm.ValidationState,"placeholder":_vm.placeHolder},on:{"blur":function($event){_vm.inputHasBeenVisited = true},"input":_vm.UpdateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }